import * as React from 'react';
import * as ReactDOM from 'react-dom';
import ActionButtons from './ActionButtons';
import DateRange from 'owa-range-datepicker/lib/store/schema/DateRange';
import RangeDatePicker from 'owa-range-datepicker/lib/components/RangeDatePicker';
import { ControlIcons } from 'owa-control-icons';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { observer } from 'mobx-react';

const styles = require('./RangeDatePickerModal.scss');

export interface RangeDatePickerModalProps extends React.HTMLAttributes<HTMLDivElement> {
    onApply: (dateRange: DateRange) => void;
    onCancelCallback: () => void;
    defaultSelectedRange?: DateRange;
}

interface RangeDatePickerModalState {
    isOpen: boolean;
    dateRange: DateRange;
}

export const RANGE_DATE_PICKER_MODAL_DIV_ID = 'RangeDatePickerModal';

@observer
export class RangeDatePickerModal extends React.Component<
    RangeDatePickerModalProps,
    RangeDatePickerModalState
> {
    constructor(props: RangeDatePickerModalProps) {
        super(props);
        this.state = {
            isOpen: true,
            dateRange: null,
        };
    }

    render() {
        return (
            <Modal isOpen={this.state.isOpen} onDismiss={this.onCancel}>
                <div className={styles.modalContainer}>
                    <div className={styles.topPart}>
                        <span className={styles.headerText}>{'Select Range'}</span>
                        <IconButton
                            iconProps={{
                                iconName: ControlIcons.Cancel,
                            }}
                            className={styles.close}
                            onClick={this.onCancel}
                        />
                    </div>
                    <RangeDatePicker
                        onDateRangeSelected={this.onDateRangeSelected}
                        dateRange={this.state.dateRange}
                        defaultSelectedRange={this.props.defaultSelectedRange}
                        className={styles.dateFilterContent}
                    />
                    <ActionButtons
                        isApplyDisabled={this.isApplyDisabled()}
                        onApplyClicked={this.onApply}
                        onCancelClicked={this.onCancel}
                    />
                </div>
            </Modal>
        );
    }
    private isApplyDisabled = () => {
        return (
            this.state.dateRange &&
            (this.state.dateRange.endDate === null || this.state.dateRange.startDate === null)
        );
    };
    private onDateRangeSelected = (dateRange: DateRange) => {
        this.setState({ dateRange: dateRange, isOpen: true });
    };

    private onApply = () => {
        this.props.onApply(this.state.dateRange);
        this.setState({ isOpen: false, dateRange: null });
    };
    private onCancel = () => {
        this.setState({ isOpen: false, dateRange: null });
        this.props.onCancelCallback();
    };
}

export default function showRangeDatePickerModal(
    resolve: (result: DateRange) => void,
    reject: () => void,
    initProps?: { defaultDateRange: DateRange }
): void {
    let rangeDatePickerModalDiv = document.getElementById(RANGE_DATE_PICKER_MODAL_DIV_ID);
    if (!rangeDatePickerModalDiv) {
        rangeDatePickerModalDiv = document.createElement('div');
        rangeDatePickerModalDiv.id = RANGE_DATE_PICKER_MODAL_DIV_ID;
        document.body.appendChild(rangeDatePickerModalDiv);
    }

    ReactDOM.render(
        <RangeDatePickerModal
            onApply={resolve}
            onCancelCallback={reject}
            key={Math.random()}
            defaultSelectedRange={initProps ? initProps.defaultDateRange : null}
        />,
        rangeDatePickerModalDiv
    );
}
